import { useTranslation } from 'next-i18next';
import { ReactNode } from 'react';
import { isNil } from 'remeda';
import { A, Box } from '@bridebook/ui';
import { IconInstagram } from '@bridebook/ui/src/icons';
import { InstagramGridItem } from '@bridebook/web/app-shared/components/supplier/sections/instagram-widget/instagram-grid-item';
import { InstagramMedia } from '@bridebook/web/app-shared/lib/supplier/types';
import componentStyles from '@bridebook/web/app-basic/components/supplier/sections/instagram-widget/instagram-widget.style';

interface IProps {
  photos?: InstagramMedia[];
  maxPhotos?: number;
  instagramUrl?: string;
  onInstagramClick?: () => void;
  renderGrid: (photos: InstagramMedia[]) => ReactNode;
  isLoggedIn: boolean;
}

const InstagramWidget = ({
  photos,
  maxPhotos,
  instagramUrl = '',
  onInstagramClick,
  renderGrid,
  isLoggedIn,
}: IProps) => {
  const { t } = useTranslation('supplier');

  const photosSliced = photos?.slice(0, maxPhotos);
  const isLoaded = !isNil(photosSliced);
  const styles = componentStyles();

  return (
    <Box style={styles.section}>
      <Box style={styles.wrapper}>
        <Box style={styles.header}>
          {t('instagramWidget.latestFromInstagram')}
          {isLoggedIn && (
            <A
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              color="space"
              noUnderline
              onClick={onInstagramClick}>
              <IconInstagram color="space" width={20} />
            </A>
          )}
        </Box>
        <Box style={styles.grid} onClick={isLoggedIn ? undefined : onInstagramClick}>
          {isLoaded
            ? renderGrid(photosSliced)
            : Array.from(Array(maxPhotos).keys()).map((id) => (
                <InstagramGridItem isLoggedIn={isLoggedIn} key={id} />
              ))}
        </Box>
      </Box>
    </Box>
  );
};

export default InstagramWidget;
